import { useMemo } from 'react';
import { buildMasterRows, interleaveDetailRows } from '../masterDetail/rowModel';

/** Stage 1–2: stamp master IDs, then interleave open detail rows. */
export const useMasterDetailRowData = <TData extends object>({
  sourceData,
  getRowId,
  isRowExpanded,
  shouldShowDetailRow,
}: {
  sourceData: TData[];
  getRowId: (data: TData) => string;
  isRowExpanded: (id: string) => boolean;
  shouldShowDetailRow?: (data: TData) => boolean;
}) => {
  const masterRows = useMemo(
    () => buildMasterRows(sourceData, getRowId),
    [sourceData, getRowId]
  );

  const rowData = useMemo(
    () => interleaveDetailRows(masterRows, isRowExpanded, shouldShowDetailRow),
    [masterRows, isRowExpanded, shouldShowDetailRow]
  );

  return rowData;
};
